
import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate, useLocation } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import axios from "axios";
import Chip from "@mui/material/Chip";
import Switch from "@mui/material/Switch";
import HOST_URL from "../../utils/Url";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import VisibilityIcon from "@mui/icons-material/Visibility";
import details from "../../../assets/images/face-recognition.png";
import reports from "../../../assets/images/report.png";
import Modal from "@mui/material/Modal";
import Logo from "../../assets/images/CSJMUlog.png";
import Watermark from "../../assets/images/CSJMUlogo.png";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ProfileImg from "../../assets/images/profile2.png"
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridActionsCellItem,
} from "@mui/x-data-grid";

import { toast, ToastContainer } from "react-toastify";
import ToastApp from "../../ToastApp";
import { usePermissionData } from "../../usePermissionData";
import dayjs from "dayjs";
import api from "../../utils/Url";
import { getISTDate } from "../../utils/Constant";
import { useFormik } from "formik";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}


interface VisitorModalProps {
  open: boolean;
  onClose: () => void;
  visitor: any; // You can define a stricter type if needed
}

const VisitorModal: React.FC<VisitorModalProps> = ({ open, onClose, visitor }) => {
  if (!visitor) return null;

  const imageSrc = visitor.member_photo
    ? `data:image/jpeg;base64,${visitor.member_photo}`
    : ProfileImg;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: 6,
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#1976d2", // blue header
          color: "#fff",
          fontWeight: 600,
          fontSize: 18,
          p: 2,
        }}
      >
        Visitor Details
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: "#fff",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent
        sx={{
          backgroundColor: "#fafafa",
          p: 3,
        }}
      >
        {/* Profile section */}
        <Stack alignItems="center" spacing={1.5} mb={3}>
          <Box
            sx={{
              width: 130,
              height: 130,
              borderRadius: "50%",
              overflow: "hidden",
              border: "3px solid #1976d2",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            <img
              src={imageSrc}
              alt={visitor.mname}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 1 }}>
            {visitor.mname}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#666", textTransform: "capitalize" }}
          >
            {visitor.mem_dept} • {visitor.mem_degree}
          </Typography>
        </Stack>

        <Divider sx={{ mb: 2 }} />

        {/* Visitor Details Grid */}
        <Grid container spacing={2}>
          {[
            { label: "Member Code", value: visitor.m_memcd },
            { label: "Category", value: visitor.mem_ctgry },
            { label: "Mobile No", value: visitor.mobileNo },
            { label: "Member Type", value: visitor.mem_type },
            { label: "Visit Date", value: moment(visitor.vdate).format("DD-MM-YYYY") },
            { label: "In Time", value: visitor.inTime },
            { label: "Out Time", value: visitor.outTime },
            { label: "Time Spent", value: visitor.spendtime },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Typography
                variant="subtitle2"
                sx={{ color: "#777", fontSize: 13 }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  color: "#222",
                }}
              >
                {item.value || "—"}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

// const VisitorModal: React.FC<VisitorModalProps> = ({ open, onClose, visitor }) => {
//   if (!visitor) return null;

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
//         Visitor Details
//         <IconButton onClick={onClose} size="small">
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent>
//         <Box sx={{ textAlign: "center", mb: 2 }}>
//           <img
//             src={visitor.member_photo ? `data:image/jpeg;base64,${visitor.member_photo}`:ProfileImg}
//             alt={visitor.mname}
//             style={{
//               width: 120,
//               height: 120,
//               borderRadius: "50%",
//               objectFit: "cover",
//             }}
//           />
//           <Typography variant="h6" sx={{ mt: 1 }}>
//             {visitor.mname}
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             {visitor.mem_dept} • {visitor.mem_degree}
//           </Typography>
//         </Box>

//         <Grid container spacing={1}>
//           <Grid item xs={6}>
//             <Typography variant="subtitle2">Member Code:</Typography>
//             <Typography>{visitor.m_memcd}</Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="subtitle2">Category:</Typography>
//             <Typography>{visitor.mem_ctgry}</Typography>
//           </Grid>

//           <Grid item xs={6}>
//             <Typography variant="subtitle2">Mobile No:</Typography>
//             <Typography>{visitor.mobileNo}</Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="subtitle2">Member Type:</Typography>
//             <Typography>{visitor.mem_type}</Typography>
//           </Grid>

//           <Grid item xs={6}>
//             <Typography variant="subtitle2">Visit Date:</Typography>
//             <Typography>{visitor.vdate}</Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="subtitle2">In Time:</Typography>
//             <Typography>{visitor.inTime}</Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="subtitle2">Out Time:</Typography>
//             <Typography>{visitor.outTime}</Typography>
//           </Grid>
//           <Grid item xs={6}>
//             <Typography variant="subtitle2">Time Spent:</Typography>
//             <Typography>{visitor.spendtime}</Typography>
//           </Grid>
//         </Grid>
//       </DialogContent>
//     </Dialog>
//   );
// };


export default function VisitorInfo() {
  const [rows, setRows] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { defaultValuestime } = getISTDate();
  let navigate = useNavigate();
  const { t } = useTranslation();
  const [columns, setColumns] = useState<any>([]);
  const [formImportData, setFormImportData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [memberCodeOptions, setMemberCodeOptions] = useState<any[]>([]);
  const [memberCodeLoading, setMemberCodeLoading] = useState(false);
  const [Category_dept_Option, setCategory_dept_Option] = React.useState<any[]>([]);
  const [Option, setOption] = React.useState<any[]>([]);
  const [memberCategoryOptions, setMemberCategoryOptions] = React.useState<any[]>([]);
  const defaultFromDate = moment(defaultValuestime).subtract(1, 'months').format("YYYY-MM-DD");
  const defaultToDate = moment(defaultValuestime).format("YYYY-MM-DD");
  const [isImportDiv,setIsImportDiv] = useState<Boolean>(false)



  const [openModal, setOpenModal] = useState(false);
const [selectedVisitor, setSelectedVisitor] = useState<any>(null);

const handleOpenModal = (visitor: any) => {
  setSelectedVisitor(visitor);
  setOpenModal(true);
};

const handleCloseModal = () => {
  setOpenModal(false);
  setSelectedVisitor(null);
};

const getImageSrc = (base64:string) => {
  if (!base64) return ProfileImg;
  if (base64.startsWith("data:image")) return base64; // already prefixed
  return `data:image/jpeg;base64,${base64}`;
};



  const formik = useFormik({
    initialValues: {
      vdate: defaultFromDate,
      todate: defaultToDate,
      m_memcd: "",
      mem_dept: "",
      mem_degree: "",
      mem_ctgry: ""
    },
    onSubmit: async (values) => {
      getList();
    },
  });

  useEffect(() => {
    getList();
    programData();
    fetchfcltydept_Data();
    fetchMemberCategories();
  }, []);

  const fetchfcltydept_Data = () => {
    const collectData = { fld_tag: "" };
    api
      .post(`Member/Getm_fcltydept`, collectData)
      .then((response) => {
        if (response.data && response.data.data) {
          const arr = response.data.data.map((items: any) => ({
            label: `${items.fclty_dept_dscr} (${items.fclty_dept_cd})`,
            value: items.fclty_dept_cd,
          }));
          setCategory_dept_Option(arr);
        } else {
          setCategory_dept_Option([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching faculty department data:", error);
        setCategory_dept_Option([]);
      });
  };

  const programData = () => {
    const collectData = {
      "branch_cd": "",
      "branch_name": ""
    };
    api
      .post(`Member/Getm_prgram`, collectData)
      .then((response) => {
        if (response.data && response.data.data) {
          const arr = response.data.data.map((items: any) => ({
            label: `${items.branch_name} (${items.branch_cd})`,
            value: items.branch_cd,
          }));
          setOption(arr);
        } else {
          setOption([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching program data:", error);
        setOption([]);
      });
  };

  const getMemberSearchResults = async (searchText: string) => {
    if (!searchText || searchText.length < 1) {
      setMemberCodeOptions([{ value: "-1", label: "Type to search members" }]);
      return;
    }

    setMemberCodeLoading(true);
    try {
      const response = await api.get(`AssigningRfid/GetMember?name=${searchText}`);
      const transformedData = response?.data?.map((item: any) => ({
        value: item?.value,
        label: item?.label
      })) || [];

      setMemberCodeOptions(transformedData.length > 0
        ? transformedData
        : [{ value: "-1", label: "No members found" }]
      );
    } catch (error) {
      console.error("Error fetching members:", error);
      setMemberCodeOptions([
        { value: "-1", label: "Error fetching members" },
      ]);
    } finally {
      setMemberCodeLoading(false);
    }
  };

  const fetchMemberCategories = async () => {
    try {
      const response = await api.post(`Member/Getm_ctgry`, { ctgry_cd: "" });
      if (response.data && response.data.data) {
        const arr = response.data.data.map((item: any) => ({
          label: `${item.ctgry_desc} (${item.ctgry_cd})`,
          value: item.ctgry_cd,
        }));
        setMemberCategoryOptions(arr);
      }
    } catch (error) {
      console.error("Error fetching member categories:", error);
      setMemberCategoryOptions([]);
    }
  };

  const getList = () => {
    const collectData = {
      vdate: formik.values.vdate,
      todate: formik.values.todate,
      m_memcd: formik.values.m_memcd,
      mem_dept: formik.values.mem_dept,
      mem_degree: formik.values.mem_degree,
      mem_ctgry: formik.values.mem_ctgry
    };

    setIsLoading(true);
    try {
      api
        .post(`Member/GetvisitorInfo`, collectData)
        .then((res: any) => {
          if (!res.data.isSuccess) {
            toast.error(res.data.mesg);
            setRows([]);
            return;
          }
          const data = res.data.data;
          const arr = data.map((item: any, index: any) => ({
            ...item,
            serialNo: index + 1,
            id: index,
            vdate: moment(item.vdate).format("DD/MM/YYYY"),
            todate: moment(item.todate).format("DD/MM/YYYY"),
            inTime: moment(item.inTime).format("hh:mm A") || "",
            outTime: item.outTime ? moment(item.outTime).format("hh:mm A") : "",
          }));
          setRows(arr);
          setIsLoading(false);

          if (data.length > 0) {
            const columns: GridColDef[] = [
              {
                field: "serialNo",
                headerName: t("text.SrNo"),
                flex: .8,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 80,
              },
              {
                field: "m_memcd",
                headerName: t("text.MemberCode"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 140,
              },
              {
                field: "mname",
                headerName: t("text.MemberName"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 140,
              },
              {
                field: "mem_dept",
                headerName: t("text.Department"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 140,
              },
              {
                field: "mem_degree",
                headerName: t("text.Program"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 140,
              },
              {
                field: "mem_ctgry",
                headerName: t("text.Category"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 140,
              },
              {
                field: "mobileNo",
                headerName: t("text.mobileNo"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 120,
              },
              {
                field: "mem_type",
                headerName: t("text.MemberType"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 130,
              },
              {
                field: "vdate",
                headerName: t("text.VisitDate"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 100,
              },
              {
                field: "inTime",
                headerName: t("text.InTime"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 100,
              },
              {
                field: "outTime",
                headerName: t("text.OutTime"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 100,
              },
              {
                field: "spendtime",
                headerName: t("text.TimeSpend"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 130,
              },
              {
                field: "visit",
                headerName: t("text.Visit"),
                flex: 1,
                headerClassName: "MuiDataGrid-colCell",
                minWidth: 80,
              },
              {
  field: "member_photo",
  headerName: t("text.Photo"),
  flex: 1,
  headerClassName: "MuiDataGrid-colCell",
  minWidth: 80,
  renderCell: (params) => (
    <Box
      onClick={() => handleOpenModal(params.row)}
      sx={{
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={getImageSrc(params.value)}
        alt="member"
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
    </Box>
  ),
},
            ];
            setColumns(columns as any);
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const handlePrintClick = async () => {
    const toastId = toast.loading("Generating Detailed Report...");

    try {
      const collectData = {
        vdate: formik.values.vdate,
        todate: formik.values.todate,
        m_memcd: formik.values.m_memcd,
        mem_dept: formik.values.mem_dept,
        mem_degree: formik.values.mem_degree,
        mem_ctgry: formik.values.mem_ctgry,
      };

      const response = await api.post(
        `Member/DownloadDetailVisitorPdf`,
        collectData
      );

      if (response.data && response.data.base64Pdf) {
        const base64Pdf = response.data.base64Pdf;
        const binaryString = window.atob(base64Pdf);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const file = new Blob([bytes.buffer], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");

        toast.update(toastId, {
          render: "Detailed Report is ready!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        throw new Error("API did not return a valid PDF file.");
      }
    } catch (error: any) {
      console.error("Error downloading the PDF", error);
      toast.update(toastId, {
        render: error.response?.data?.mesg || "Failed to generate detailed report.",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const handleSummaryPrintClick = async () => {
    const toastId = toast.loading("Generating Summary Report...");

    try {
      const collectData = {
        vdate: formik.values.vdate,
        todate: formik.values.todate,
        m_memcd: formik.values.m_memcd,
        mem_dept: formik.values.mem_dept,
        mem_degree: formik.values.mem_degree,
        mem_ctgry: formik.values.mem_ctgry,
      };

      const response = await api.post(
        `Member/DownloadSummaryVisitorPdf`,
        collectData
      );

      if (response.data && response.data.base64Pdf) {
        const base64Pdf = response.data.base64Pdf;
        const binaryString = window.atob(base64Pdf);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const file = new Blob([bytes.buffer], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");

        toast.update(toastId, {
          render: "Summary Report is ready!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        throw new Error("API did not return a valid PDF file.");
      }
    } catch (error: any) {
      console.error("Error downloading the summary PDF", error);
      toast.update(toastId, {
        render: error.response?.data?.mesg || "Failed to generate summary report.",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };


  const downloadDataFormat = async () => {
  try {
    const response = await api.get("VisitorInfoex/download-template", {
      responseType: "blob", // 👈 important
    });

    // Blob बनाओ
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });

    // Temporary link बनाओ
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "VisitorTemplate.xlsx"; // 👈 file name
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);

  } catch (error) {
    console.error("Download error", error);
  }
};


const handleFileChange = (event:any) => {
    const file = event.target.files[0];
    if (file) {
      // सिर्फ Excel allow करो
      if (
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel"
      ) {
        setFormImportData(file);
      } else {
        toast.error("Please select a valid Excel file (.xlsx or .xls)");
      }
    }
  };

  const importDataExcel = async () => {
    if (!formImportData) {
      toast.error("Please select an Excel file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", formImportData); // 👈 backend को भेजने के लिए form-data बनाओ

    try {
      setLoading(true);
      const response = await api.post(
        "VisitorInfoex/import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(response.data.message || "फाइल सफलतापूर्वक इम्पोर्ट की गई!");
      setIsImportDiv(false);
      setFormImportData(null); // reset file after upload
    } catch (error) {
      console.error("Import Error", error);
      toast.error("फाइल इम्पोर्ट करने में समस्या आई!");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div></div>
      <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
        <Card
          style={{
            width: "100%",
            height: "50%",
            backgroundColor: "#E9FDEE",
            border: ".5px solid green ",
          }}
        >
          <Paper
            sx={{
              width: "100%",
              overflow: "hidden",
              "& .MuiDataGrid-colCell": {
                backgroundColor: "#2B4593",
                color: "#fff",
                fontSize: 18,
                fontWeight: 800,
              },
            }}
            style={{ padding: "10px" }}
          >
            <ConfirmDialog />
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ padding: "20px" }}
              align="left"
            >
              {t("text.VisitorInfo")}
            </Typography>
            <Divider />

            <Box height={10} />
            <ToastContainer />

            <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        mb: 2,
        p: 2,
        borderRadius: "16px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
    >
      {/* Download Button */}
      <Grid item xs={12} sm={6} md={3}>
        <Button
          fullWidth
          type="button"
          variant="contained"
          sx={{
            backgroundColor: "#279270ff",
            py: 1.2,
            borderRadius: "12px",
            boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
            "&:hover": { backgroundColor: "#1e7a59" },
          }}
          onClick={downloadDataFormat}
        >
          {t("text.downloadformat")}
        </Button>
      </Grid>

      {/* Toggle Import Button */}
      <Grid item xs={12} sm={6} md={3}>
        <Button
          fullWidth
          type="button"
          variant="contained"
          sx={{
            backgroundColor: "#295da1ff",
            py: 1.2,
            borderRadius: "12px",
            boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
            "&:hover": { backgroundColor: "#214b85" },
          }}
          onClick={() => setIsImportDiv(!isImportDiv)}
        >
          {t("text.ImportData")}
        </Button>
      </Grid>

      {/* Import Section */}
      {isImportDiv && (
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 2,
              mt: { xs: 2, md: 0 },
            }}
          >
            {/* Hidden file input */}
            <input
              accept=".xlsx,.xls"
              style={{ display: "none" }}
              id="excel-upload"
              type="file"
              onChange={handleFileChange}
            />

            {/* Upload button */}
            <label htmlFor="excel-upload">
              <Button
                variant="contained"
                component="span"
                startIcon={<UploadFileIcon />}
                sx={{
                  textTransform: "none",
                  borderRadius: "12px",
                  px: 3,
                  py: 1.2,
                  backgroundColor: "#6a4bc3",
                  "&:hover": { backgroundColor: "#5539a5" },
                }}
              >
                {formImportData ? "Change File" : "Upload Excel"}
              </Button>
            </label>

            {/* Import button */}
            {formImportData && (
              <Button
                variant="outlined"
                color="success"
                sx={{
                  textTransform: "none",
                  borderRadius: "12px",
                  px: 3,
                  py: 1.2,
                  fontWeight: 500,
                }}
                onClick={importDataExcel}
                disabled={loading}
              >
                {loading ? <CircularProgress size={22} /> : "Import Data"}
              </Button>
            )}

            {/* Show selected filename */}
            {formImportData && (
              <Typography
                variant="body2"
                sx={{ mt: { xs: 1, md: 0 }, fontStyle: "italic" }}
              >
                Selected File: <b>{formImportData.name}</b>
              </Typography>
            )}
          </Box>
        </Grid>
      )}
    </Grid>

            
            <form onSubmit={formik.handleSubmit}>
              <Grid item xs={12} container spacing={2}>
                <Grid item xs={12} sm={6} lg={4}>
                  <TextField
                    label={t("text.fromDate")}
                    type="date"
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="vdate"
                    id="vdate"
                    value={formik.values.vdate}
                    placeholder={t("text.fromDate")}
                    onChange={formik.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={4}>
                  <TextField
                    label={t("text.todate")}
                    type="date"
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="todate"
                    id="todate"
                    value={formik.values.todate}
                    placeholder={t("text.todate")}
                    onChange={formik.handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <Autocomplete
                    freeSolo
                    options={memberCodeOptions}
                    loading={memberCodeLoading}
                    filterOptions={(options) => options.filter(option => option.value !== "-1")}
                    onInputChange={(event, newInputValue) => {
                      const timer = setTimeout(() => {
                        getMemberSearchResults(newInputValue);
                      }, 300);
                      return () => clearTimeout(timer);
                    }}
                    onChange={(event, newValue) => {
                      if (newValue && typeof newValue !== 'string' && newValue.value !== "-1") {
                        formik.setFieldValue("m_memcd", newValue.value);
                      }
                    }}
                    getOptionLabel={(option) =>
                      typeof option === 'string' ? option : option?.label || ""
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("text.MemberCode")}
                        name="m_memcd"
                        id="m_memcd"
                        size="small"
                        placeholder="Start typing member name or code"
                        value={formik.values.m_memcd}
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <Autocomplete
                    disablePortal
                    id="department-autocomplete"
                    options={Category_dept_Option}
                    getOptionLabel={(option) => option?.label || ""}
                    fullWidth
                    size="small"
                    value={
                      Category_dept_Option.find(opt => opt.value === formik.values.mem_dept) || null
                    }
                    onChange={(_, newValue) => {
                      formik.setFieldValue("mem_dept", newValue?.value || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Department"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <Autocomplete
                    disablePortal
                    id="program-autocomplete"
                    options={Option}
                    getOptionLabel={(option) => option?.label || ""}
                    fullWidth
                    size="small"
                    value={
                      Option.find(opt => opt.value === formik.values.mem_degree) || null
                    }
                    onChange={(e, newValue) => {
                      formik.setFieldValue("mem_degree", newValue?.value || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Program"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                  <Autocomplete
                    disablePortal
                    id="member-category-autocomplete"
                    options={memberCategoryOptions}
                    getOptionLabel={(option) => option?.label || ""}
                    fullWidth
                    size="small"
                    value={
                      memberCategoryOptions.find(opt => opt.value === formik.values.mem_ctgry) || null
                    }
                    onChange={(_, newValue) => {
                      formik.setFieldValue("mem_ctgry", newValue?.value || "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Member Category"
                      />
                    )}
                  />
                </Grid>

                <Grid xs={12} item>
                  <div style={{ justifyContent: "space-between", flex: 2 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      style={{
                        width: "23%",
                        backgroundColor: "#059669",
                        margin: "1%",
                      }}
                    >
                      {t("text.show")}
                    </Button>

                    <Button
                      type="reset"
                      variant="contained"
                      style={{
                        width: "23%",
                        backgroundColor: "#F43F5E",
                        margin: "1%",
                      }}
                      onClick={() => formik.resetForm()}
                    >
                      {t("text.reset")}
                    </Button>

                    <Button
                      type="button"
                      variant="contained"
                      style={{
                        width: "23%",
                        backgroundColor: "#5682e8",
                        margin: "1%",
                      }}
                      onClick={handlePrintClick}
                    >
                      Detailed Report
                    </Button>

                    <Button
                      type="button"
                      variant="contained"
                      style={{
                        width: "23%",
                        backgroundColor: "#20B2AA",
                        margin: "1%",
                      }}
                      onClick={handleSummaryPrintClick}
                    >
                      Summary Report
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </form>

            <Box>
              <br></br>
              <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
            </Box>
          </Paper>
        </Card>
      </Grid>
      <VisitorModal
  open={openModal}
  onClose={handleCloseModal}
  visitor={selectedVisitor}
/>

    </>
  );
}













// import * as React from "react";
// import Paper from "@mui/material/Paper";
// import { useEffect, useState } from "react";
// import {
//   Autocomplete,
//   Box,
//   Button,
//   Divider,
//   Stack,
//   TextField,
//   Typography,
// } from "@mui/material";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";
// import PrintIcon from "@mui/icons-material/Print";
// import { useNavigate, useLocation } from "react-router-dom";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import axios from "axios";
// import Chip from "@mui/material/Chip";
// import Switch from "@mui/material/Switch";
// import HOST_URL from "../../utils/Url";
// import moment from "moment";
// import CircularProgress from "@mui/material/CircularProgress";
// import { useTranslation } from "react-i18next";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import details from "../../../assets/images/face-recognition.png";
// import reports from "../../../assets/images/report.png";
// import Modal from "@mui/material/Modal";
// import Logo from "../../assets/images/CSJMUlog.png";
// import Watermark from "../../assets/images/CSJMUlogo.png";
// import {
//   DataGrid,
//   GridColDef,
//   GridToolbar,
//   GridActionsCellItem,
// } from "@mui/x-data-grid";

// import { toast, ToastContainer } from "react-toastify";
// import ToastApp from "../../ToastApp";
// import { usePermissionData } from "../../usePermissionData";
// import dayjs from "dayjs";
// import api from "../../utils/Url";
// import { getISTDate } from "../../utils/Constant";
// import { useFormik } from "formik";

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "180vh",
//   height: "85vh",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// export default function VisitorInfo() {
//   const [rows, setRows] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const { defaultValuestime } = getISTDate();
//   let navigate = useNavigate();
//   const { t } = useTranslation();
//   const [columns, setColumns] = useState<any>([]);
//   const [memberCodeOptions, setMemberCodeOptions] = useState<any[]>([]);
//   const [memberCodeLoading, setMemberCodeLoading] = useState(false);
//   const [Category_dept_Option, setCategory_dept_Option] = React.useState<any[]>([]);
//   const [Option, setOption] = React.useState<any[]>([]);
//   const [memberCategoryOptions, setMemberCategoryOptions] = React.useState<any[]>([]);
// const defaultFromDate = moment(defaultValuestime).subtract(1, 'months').format("YYYY-MM-DD");
// const defaultToDate = moment(defaultValuestime).format("YYYY-MM-DD");
//   const formik = useFormik({
//     initialValues: {
//      vdate: defaultFromDate,
//       todate: defaultToDate,
//       m_memcd: "",
//       mem_dept: "",
//       mem_degree: "",
//       mem_ctgry: ""
//     },
//     onSubmit: async (values) => {
//       getList();
//     },
//   });

//   useEffect(() => {
//     getList();
//     programData();
//     fetchfcltydept_Data();
//      fetchMemberCategories();
//   }, []);

//   const fetchfcltydept_Data = () => {
//     const collectData = { fld_tag: "" };
//     api
//       .post(`Member/Getm_fcltydept`, collectData)
//       .then((response) => {
//         if (response.data && response.data.data) {
//           const arr = response.data.data.map((items: any) => ({
//             label: `${items.fclty_dept_dscr} (${items.fclty_dept_cd})`,
//             value: items.fclty_dept_cd,
//           }));
//           setCategory_dept_Option(arr);
//         } else {
//           setCategory_dept_Option([]);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching faculty department data:", error);
//         setCategory_dept_Option([]);
//       });
//   };

//   const programData = () => {
//     const collectData = {
//       "branch_cd": "",
//       "branch_name": ""
//     };
//     api
//       .post(`Member/Getm_prgram`, collectData)
//       .then((response) => {
//         if (response.data && response.data.data) {
//           const arr = response.data.data.map((items: any) => ({
//             label: `${items.branch_name} (${items.branch_cd})`,
//             value: items.branch_cd,
//           }));
//           setOption(arr);
//         } else {
//           setOption([]);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching program data:", error);
//         setOption([]);
//       });
//   };

// const getMemberSearchResults = async (searchText: string) => {
//   if (!searchText || searchText.length < 1) {
//     setMemberCodeOptions([{ value: "-1", label: "Type to search members" }]);
//     return;
//   }
  
//   setMemberCodeLoading(true);
//   try {
//     const response = await api.get(`AssigningRfid/GetMember?name=${searchText}`);
//     const transformedData = response?.data?.map((item: any) => ({
//       value: item?.value,
//       label: item?.label
//     })) || [];
    
//     setMemberCodeOptions(transformedData.length > 0 
//       ? transformedData 
//       : [{ value: "-1", label: "No members found" }]
//     );
//   } catch (error) {
//     console.error("Error fetching members:", error);
//     setMemberCodeOptions([
//       { value: "-1", label: "Error fetching members" },
//     ]);
//   } finally {
//     setMemberCodeLoading(false);
//   }
// };

//   const fetchMemberCategories = async () => {
//   try {
//     const response = await api.post(`Member/Getm_ctgry`, { ctgry_cd: "" });
//     if (response.data && response.data.data) {
//       const arr = response.data.data.map((item: any) => ({
//         label: `${item.ctgry_desc} (${item.ctgry_cd})`,
//         value: item.ctgry_cd,
//       }));
//       setMemberCategoryOptions(arr);
//     }
//   } catch (error) {
//     console.error("Error fetching member categories:", error);
//     setMemberCategoryOptions([]);
//   }
// };

//   const getList = () => {
//     const collectData = {
//       vdate: formik.values.vdate,
//        todate: formik.values.todate,
      
//       m_memcd: formik.values.m_memcd,
//       mem_dept: formik.values.mem_dept,
//       mem_degree: formik.values.mem_degree,
//       mem_ctgry: formik.values.mem_ctgry
//     };
    
//     setIsLoading(true);
//     try {
//       api
//         .post(`Member/GetvisitorInfo`, collectData)
//         .then((res: any) => {
//           if (!res.data.isSuccess) {
//             toast.error(res.data.mesg);
//             setRows([]);
//             return;
//           }
//           const data = res.data.data;
//           const arr = data.map((item: any, index: any) => ({
//             ...item,
//             serialNo: index + 1,
//             id: index,
//             vdate: moment(item.vdate).format("DD/MM/YYYY"),
//             todate: moment(item.todate).format("DD/MM/YYYY"),
//             inTime: moment(item.inTime).format("hh:mm A") || "",
//             outTime: item.outTime ? moment(item.outTime).format("hh:mm A") : "",
//           }));
//           setRows(arr);
//           setIsLoading(false);

//           if (data.length > 0) {
//             const columns: GridColDef[] = [
//               {
//                 field: "serialNo",
//                 headerName: t("text.SrNo"),
//                 flex: .8,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 80,
//               },
//               {
//                 field: "m_memcd",
//                 headerName: t("text.MemberCode"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 140,
//               },
//               {
//                 field: "mname",
//                 headerName: t("text.MemberName"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 140,
//               },
//                 {
//                 field: "mem_dept",
//                 headerName: t("text.Department"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 140,
//               },
//                 {
//                 field: "mem_degree",
//                 headerName: t("text.Program"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 140,
//               },
//                      {
//                 field: "mem_ctgry",
//                 headerName: t("text.Category"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 140,
//               },
              
              
//               {
//                 field: "mobileNo",
//                 headerName: t("text.mobileNo"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 120,
//               },
//               {
//                 field: "mem_type",
//                 headerName: t("text.MemberType"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 130,
//               },
//               {
//                 field: "vdate",
//                 headerName: t("text.VisitDate"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 100,
//               },
//               {
//                 field: "inTime",
//                 headerName: t("text.InTime"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 100,
//               },
//               {
//                 field: "outTime",
//                 headerName: t("text.OutTime"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 100,
//               },
//               {
//                 field: "spendtime",
//                 headerName: t("text.TimeSpend"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 130,
//               },
//               {
//                 field: "visit",
//                 headerName: t("text.Visit"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 80,
//               },
//             ];
//             setColumns(columns as any);
//           }
//         });
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setIsLoading(false);
//     }
//   };

//   const handlePrintClick = () => {
//     if (!rows || rows.length === 0) {
//       toast.error("No data to print!");
//       return;
//     }

//     const printWindow = window.open("", "_blank");
//     const content = `
//       <html>
//       <head>
//           <title>Print Report - CSJMU Library</title>
//           <style>
//               body {
//                   font-family: Arial, sans-serif;
//                   margin: 20px;
//                   position: relative;
//               }

//               .header {
//                   display: flex;
//                   align-items: center;
//                   justify-content: center;
//                   border-bottom: 3px solid #0d3b5c;
//                   padding: 30px 0;
//                   margin-bottom: 30px;
//                   position: relative;
//               }

//               .logo {
//                   width: 100px;
//                   height: auto;
//                   position: absolute;
//                   left: 20px;
//                   top: 50%;
//                   transform: translateY(-50%);
//               }

//               .title {
//                   font-size: 24px;
//                   font-weight: bold;
//                   color: #0d3b5c;
//                   text-transform: uppercase;
//                   text-align: center;
//               }

//               h2 {
//                   text-align: center;
//                   margin-bottom: 20px;
//                   color: #0d3b5c;
//               }

//               table {
//                   width: 100%;
//                   border-collapse: collapse;
//                   margin-top: 10px;
//                   position: relative;
//                   z-index: 2;
//               }

//               th, td {
//                   border: 1px solid black;
//                   padding: 10px;
//                   text-align: left;
//               }

//               th {
//                   background-color: #0d3b5c;
//                   color: white;
//                   text-align: center;
//               }

//               td {
//                   text-align: center;
//               }

//               .watermark {
//                   position: fixed;
//                   top: 50%;
//                   left: 50%;
//                   transform: translate(-50%, -50%);
//                   width: 50%;
//                   height: auto;
//                   z-index: 1;
//                   opacity: 0.8;
//               }
//           </style>
//       </head>
//       <body>
//           <!-- Header -->
//           <div class="header">
//               <img class="logo" src="${Logo}" alt="CSJMU Logo" id="logo">
//               <div class="title">CSJMU LIBRARY KANPUR</div>
//           </div>

//           <!-- Watermark -->
//           <img class="watermark" src="${Watermark}" alt="Watermark Logo" id="watermark">

//           <h2>Visitor Information</h2>

//           <!-- Report Table -->
//           <table>
//               <thead>
//                   <tr>
//                       <th>Member Code</th>
//                       <th>Name</th>
//                       <th>Mobile</th>
//                       <th>Member Type</th>
//                       <th>Visit Date</th>
//                       <th>IN Time</th>
//                       <th>Out Time</th>
//                       <th>Time Spent</th>
//                       <th>Visit Count</th>
//                   </tr>
//               </thead>
//               <tbody>
//                   ${(rows || [])
//                     .map((row: any) => `
//                       <tr>
//                           <td>${row.m_memcd}</td>
//                           <td>${row.mname}</td>
//                           <td>${row.mobileNo}</td>
//                           <td>${row.mem_type}</td>
//                           <td>${row.vdate}</td>
//                           <td>${row.inTime}</td>
//                           <td>${row.outTime}</td>
//                           <td>${row.spendtime}</td>
//                           <td>${row.visit}</td>
//                       </tr>
//                   `).join("")}
//               </tbody>
//           </table>

//           <script>
//               function waitForImages() {
//                   const images = document.querySelectorAll("img");
//                   let loadedCount = 0;

//                   images.forEach(img => {
//                       if (img.complete) {
//                           loadedCount++;
//                       } else {
//                           img.onload = img.onerror = () => {
//                               loadedCount++;
//                               if (loadedCount === images.length) {
//                                   window.print();
//                               }
//                           };
//                       }
//                   });

//                   if (loadedCount === images.length) {
//                       window.print();
//                   }
//               }

//               waitForImages();
//           </script>
//       </body>
//       </html>
//     `;

//     if (printWindow) {
//       setTimeout(() => {
//         printWindow.document.write(content);
//         printWindow.document.close();
//       }, 1000);
//     } else {
//       console.error("Failed to open print window.");
//     }
//   };

//   return (
//     <>
//       <div></div>
//       <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
//         <Card
//           style={{
//             width: "100%",
//             height: "50%",
//             backgroundColor: "#E9FDEE",
//             border: ".5px solid green ",
//           }}
//         >
//           <Paper
//             sx={{
//               width: "100%",
//               overflow: "hidden",
//               "& .MuiDataGrid-colCell": {
//                 backgroundColor: "#2B4593",
//                 color: "#fff",
//                 fontSize: 18,
//                 fontWeight: 800,
//               },
//             }}
//             style={{ padding: "10px" }}
//           >
//             <ConfirmDialog />
//             <Typography
//               gutterBottom
//               variant="h5"
//               component="div"
//               sx={{ padding: "20px" }}
//               align="left"
//             >
//               {t("text.VisitorInfo")}
//             </Typography>
//             <Divider />

//             <Box height={10} />
//             <ToastContainer />
//             <form onSubmit={formik.handleSubmit}>
//               <Grid item xs={12} container spacing={2}>
//                 <Grid item xs={12} sm={6} lg={4}>
//                   <TextField
//                     label={t("text.fromDate")}
//                     type="date"
//                     variant="outlined"
//                     fullWidth
//                     size="small"
//                     name="vdate"
//                     id="vdate"
//                     value={formik.values.vdate}
//                     placeholder={t("text.fromDate")}
//                     onChange={formik.handleChange}
//                   />
//                 </Grid>
//                    <Grid item xs={12} sm={6} lg={4}>
//                   <TextField
//                     label={t("text.todate")}
//                     type="date"
//                     variant="outlined"
//                     fullWidth
//                     size="small"
//                     name="todate"
//                     id="todate"
//                     value={formik.values.todate}
//                     placeholder={t("text.todate")}
//                     onChange={formik.handleChange}
//                   />
//                 </Grid>

// <Grid item xs={12} sm={6} lg={4}>
//   <Autocomplete
//     freeSolo
//     options={memberCodeOptions}
//     loading={memberCodeLoading}
//     filterOptions={(options) => options.filter(option => option.value !== "-1")}
//     onInputChange={(event, newInputValue) => {
//       // Debounce the API call
//       const timer = setTimeout(() => {
//         getMemberSearchResults(newInputValue);
//       }, 300);
      
//       // Clear previous timer
//       return () => clearTimeout(timer);
//     }}
//     onChange={(event, newValue) => {
//       if (newValue && typeof newValue !== 'string' && newValue.value !== "-1") {
//         formik.setFieldValue("m_memcd", newValue.value);
//       }
//     }}
//     getOptionLabel={(option) => 
//       typeof option === 'string' ? option : option?.label || ""
//     }
//     renderInput={(params) => (
//       <TextField
//         {...params}
//         label={t("text.MemberCode")}
//         name="m_memcd"
//         id="m_memcd"
//         size="small"
//         placeholder="Start typing member name or code"
//         value={formik.values.m_memcd}
//         onChange={(e) => {
//           // Handle direct input if needed
//           formik.handleChange(e);
//         }}
//       />
//     )}
//     isOptionEqualToValue={(option, value) => 
//       option.value === value.value
//     }
//   />
// </Grid>

//                 <Grid item xs={12} sm={6} lg={4}>
//                   <Autocomplete
//                     disablePortal
//                     id="department-autocomplete"
//                     options={Category_dept_Option}
//                     getOptionLabel={(option) => option?.label || ""}
//                     fullWidth
//                     size="small"
//                     value={
//                       Category_dept_Option.find(opt => opt.value === formik.values.mem_dept) || null
//                     }
//                     onChange={(_, newValue) => {
//                       formik.setFieldValue("mem_dept", newValue?.value || "");
//                     }}
//                     renderInput={(params) => (
//                       <TextField 
//                         {...params} 
//                         label="Select Department" 
//                       />
//                     )}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6} lg={4}>
//                   <Autocomplete
//                     disablePortal
//                     id="program-autocomplete"
//                     options={Option}
//                     getOptionLabel={(option) => option?.label || ""}
//                     fullWidth
//                     size="small"
//                     value={
//                       Option.find(opt => opt.value === formik.values.mem_degree) || null
//                     }
//                     onChange={(e, newValue) => {
//                       formik.setFieldValue("mem_degree", newValue?.value || "");
//                     }}
//                     renderInput={(params) => (
//                       <TextField 
//                         {...params} 
//                         label="Select Program" 
//                       />
//                     )}
//                   />
//                 </Grid>

//                <Grid item xs={12} sm={6} lg={4}>
//   <Autocomplete
//     disablePortal
//     id="member-category-autocomplete"
//     options={memberCategoryOptions}
//     getOptionLabel={(option) => option?.label || ""}
//     fullWidth
//     size="small"
//     value={
//       memberCategoryOptions.find(opt => opt.value === formik.values.mem_ctgry) || null
//     }
//     onChange={(_, newValue) => {
//       formik.setFieldValue("mem_ctgry", newValue?.value || "");
//     }}
//     renderInput={(params) => (
//       <TextField 
//         {...params} 
//         label="Member Category" 
//       />
//     )}
//   />
// </Grid>

//                 <Grid xs={12} item>
//                   <div style={{ justifyContent: "space-between", flex: 2 }}>
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       style={{
//                         width: "30%",
//                         backgroundColor: "#059669",
//                         margin: "1%",
//                       }}
//                     >
//                       {t("text.show")}
//                     </Button>

//                     <Button
//                       type="reset"
//                       variant="contained"
//                       style={{
//                         width: "30%",
//                         backgroundColor: "#F43F5E",
//                         margin: "1%",
//                       }}
//                       onClick={() => formik.resetForm()}
//                     >
//                       {t("text.reset")}
//                     </Button>

//                     <Button
//                       type="reset"
//                       variant="contained"
//                       style={{
//                         width: "30%",
//                         backgroundColor: "#5682e8",
//                         margin: "1%",
//                       }}
//                       onClick={() => handlePrintClick()}
//                     >
//                       {t("text.Print")}
//                     </Button>
//                   </div>
//                 </Grid>
//               </Grid>
//             </form>

//             <Box>
//               <br></br>
//               <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
//                 <DataGrid
//                   rows={rows}
//                   columns={columns}
//                   autoHeight
//                   slots={{
//                     toolbar: GridToolbar,
//                   }}
//                   rowSpacingType="border"
//                   pagination={true}
//                   pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                     value: size,
//                     label: `${size}`,
//                   }))}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: 5 } },
//                   }}
//                   slotProps={{
//                     toolbar: {
//                       showQuickFilter: true,
//                     },
//                   }}
//                 />
//               </div>
//             </Box>
//           </Paper>
//         </Card>
//       </Grid>
//     </>
//   );
// }







// import * as React from "react";
// import Paper from "@mui/material/Paper";
// import { useEffect, useState } from "react";
// import {
//   Autocomplete,
//   Box,
//   Button,
//   Divider,
//   Stack,
//   TextField,
//   Typography,
// } from "@mui/material";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";
// import PrintIcon from "@mui/icons-material/Print";
// import { useNavigate, useLocation } from "react-router-dom";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import axios from "axios";
// import Chip from "@mui/material/Chip";
// import Switch from "@mui/material/Switch";
// import HOST_URL from "../../utils/Url";
// import moment from "moment";
// import CircularProgress from "@mui/material/CircularProgress";
// import { useTranslation } from "react-i18next";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import details from "../../../assets/images/face-recognition.png";
// import reports from "../../../assets/images/report.png";
// import Modal from "@mui/material/Modal";
// import Logo from "../../assets/images/CSJMUlog.png";
// import Watermark from "../../assets/images/CSJMUlogo.png";
// import {
//   DataGrid,
//   GridColDef,
//   GridToolbar,
//   GridActionsCellItem,
// } from "@mui/x-data-grid";

// import { toast, ToastContainer } from "react-toastify";
// import ToastApp from "../../ToastApp";
// import { usePermissionData } from "../../usePermissionData";
// import dayjs from "dayjs";
// import api from "../../utils/Url";
// import { getISTDate } from "../../utils/Constant";
// import { useFormik } from "formik";


// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "180vh",
//   height: "85vh",
//   bgcolor: "#f5f5f5",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: 10,
// };

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// export default function VisitorInfo() {
//   const [rows, setRows] = useState<any>([]);
//   const [isLoading, setIsLoading] = useState(true);

//   const { defaultValuestime } = getISTDate();

//   let navigate = useNavigate();
//   const { t } = useTranslation();


//   const [columns, setColumns] = useState<any>([]);
//   const [memberCode, setMemberCode] = useState([{ value: -1, label: "Select Member Code" }])


//   // Filter Today19-06-2025
// const [applicableAcceOption, setApplicableAcceOptionState] = React.useState<any[]>([{ value: "-1", label: "Member Code" }]);
// const [Category_dept_Option, setCategory_dept_Option] = React.useState<any[]>([]);
// const [progData, setProgData] = React.useState<string>("");
// const [deptData, setDeptData] = React.useState<string>("");
// const [Option, setOption] = React.useState<any[] >([]);
// const [applicableAcceOptionMemName, setApplicableAcceOptionMemName,] = React.useState<any | null>(null);
// const [timerCheck, setTimerCheck] =React.useState<NodeJS.Timeout | null>(null);


//   useEffect(() => {
//     getMemberCode();
//     getList();
//     programData();
//     fetchfcltydept_Data();
//   }, [isLoading]);

//   React.useEffect(() => {
//     return () => {
//       if (timerCheck) {
//         clearTimeout(timerCheck);
//       }
//     };
//   }, [timerCheck]);

 

//   const getMemberCode = async () => {
//     const collectData = {
//       mem_cd: "",
//       mem_ctgry: "",
//       // mem_ctgry:"CC",
//       mem_inst: "",
//       mem_dept: "",
//       mem_degree: "",
//       image: false

//     };
//     const response = await api.post(
//       `Member/Getm_member`,
//       collectData
//     );
//     const data = response.data.data;
//     const arr = data.map((item: any) => {
//       return {
//         value: item.id,
//         label: `${item.id} - ${item.empName}`
//       }
//     })
//     setMemberCode(arr);

//   }

//    const fetchfcltydept_Data = () => {
//       const collectData = { fld_tag: "" };
//       api
//         .post(`Member/Getm_fcltydept`, collectData)
//         .then((response) => {
//           if (response.data && response.data.data) {
//             const arr = response.data.data.map((items: any) => ({
//               label: `${items.fclty_dept_dscr} (${items.fclty_dept_cd})`,
//               value: items.fclty_dept_cd,
//             }));
//             setCategory_dept_Option(arr);
//           } else {
//             setCategory_dept_Option([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching faculty department data:", error);
//           setCategory_dept_Option([]);
//         });
//     };
  
//     const programData = () => {
//       const collectData = {
//         "branch_cd": "",
//         "branch_name": ""
//       };
//       api
//         .post(`Member/Getm_prgram`, collectData)
//         .then((response) => {
//           if (response.data && response.data.data) {
//             const arr = response.data.data.map((items: any) => ({
//               label: `${items.branch_name} (${items.branch_cd})`,
//               value: items.branch_cd,
//             }));
//             setOption(arr);
//           } else {
//             setOption([]);
//           }
//         })
//         .catch((error) => {
//           console.error("Error fetching program data:", error);
//           setOption([]);
//         });
//     };


//   const handlePrintClick = () => {
//     console.log("Print Clicked");
//     if (!rows || rows.length === 0) {
//       toast.error("No data to print!");
//       return;
//     }

//     const printWindow = window.open("", "_blank");
//     const content = `
//           <html>
//           <head>
//               <title>Print Report - CSJMU Library</title>
//               <style>
//                   body {
//                       font-family: Arial, sans-serif;
//                       margin: 20px;
//                       position: relative;
//                   }

//                   .header {
//                       display: flex;
//                       align-items: center;
//                       justify-content: center;
//                       border-bottom: 3px solid #0d3b5c;
//                       padding: 30px 0;
//                       margin-bottom: 30px;
//                       position: relative;
//                   }

//                   .logo {
//                       width: 100px;
//                       height: auto;
//                       position: absolute;
//                       left: 20px;
//                       top: 50%;
//                       transform: translateY(-50%);
//                   }

//                   .title {
//                       font-size: 24px;
//                       font-weight: bold;
//                       color: #0d3b5c;
//                       text-transform: uppercase;
//                       text-align: center;
//                   }

//                   h2 {
//                       text-align: center;
//                       margin-bottom: 20px;
//                       color: #0d3b5c;
//                   }

//                   table {
//                       width: 100%;
//                       border-collapse: collapse;
//                       margin-top: 10px;
//                       position: relative;
//                       z-index: 2;
//                   }

//                   th, td {
//                       border: 1px solid black;
//                       padding: 10px;
//                       text-align: left;
//                   }

//                   th {
//                       background-color: #0d3b5c;
//                       color: white;
//                       text-align: center;
//                   }

//                   td {
//                       text-align: center;
//                   }

//                   .watermark {
//                       position: fixed;
//                       top: 50%;
//                       left: 50%;
//                       transform: translate(-50%, -50%);
//                       width: 50%;
//                       height: auto;
//                       z-index: 1;
//                       opacity: 0.8;
//                   }
//               </style>
//           </head>
//           <body>
//               <!-- Header -->
//               <div class="header">
//                   <img class="logo" src="${Logo}" alt="CSJMU Logo" id="logo">
//                   <div class="title">CSJMU LIBRARY KANPUR</div>
//               </div>

//               <!-- Watermark -->
//               <img class="watermark" src="${Watermark}" alt="Watermark Logo" id="watermark">

//               <h2>Visitor Information</h2>

//               <!-- Report Table -->
//               <table>
//                   <thead>
//                       <tr>
//                           <th>Member Code</th>
//                           <th>Name</th>
//                           <th>Mobile</th>
//                           <th>Member Type</th>
//                           <th>Visit Date</th>
//                           <th>IN Time</th>
//                           <th>Out Time</th>
//                           <th>Time Spent</th>
//                           <th>Visit Count</th>
//                       </tr>
//                   </thead>
//                   <tbody>
//                       ${(rows || [])
//         .map((row: any) => `
//                           <tr>
//                               <td>${row.m_memcd}</td>
//                               <td>${row.mname}</td>
//                               <td>${row.mobileNo}</td>
//                               <td>${row.mem_type}</td>
//                               <td>${row.vdate}</td>
//                               <td>${row.inTime}</td>
//                               <td>${row.outTime}</td>
//                               <td>${row.spendtime}</td>
//                               <td>${row.visit}</td>
//                           </tr>
//                       `).join("")}
//                   </tbody>
//               </table>

//               <script>
//                   function waitForImages() {
//                       const images = document.querySelectorAll("img");
//                       let loadedCount = 0;

//                       images.forEach(img => {
//                           if (img.complete) {
//                               loadedCount++;
//                           } else {
//                               img.onload = img.onerror = () => {
//                                   loadedCount++;
//                                   if (loadedCount === images.length) {
//                                       window.print();
//                                   }
//                               };
//                           }
//                       });

//                       if (loadedCount === images.length) {
//                           window.print();
//                       }
//                   }

//                   waitForImages();
//               </script>
//           </body>
//           </html>

//             `;

//     if (printWindow) {
//       setTimeout(() => {
//         printWindow.document.write(content);
//         printWindow.document.close();
//       }, 1000);
//     } else {
//       console.error("Failed to open print window.");
//     }

//   };


//   const formik = useFormik({
//     initialValues: {
//       "vdate": moment(defaultValuestime).format("YYYY-MM-DD"),
//       "m_memcd": "",
//     },
//     onSubmit: async (values) => {
//       getList();
//     },
//   });


//   const getList = () => {
//     const collectData = {
//       "vdate": formik.values.vdate,
//       "m_memcd": formik.values.m_memcd,
//     };
//     try {
//       api
//         .post(`Member/GetvisitorInfo`, collectData)
//         .then((res: any) => {
//           if (!res.data.isSuccess) {
//             toast.error(res.data.mesg);
//             setRows([]);
//             return;
//           }
//           const data = res.data.data;
//           const arr = data.map((item: any, index: any) => ({
//             ...item,
//             serialNo: index + 1,
//             id: index,
//             vdate: moment(item.vdate).format("DD/MM/YYYY"),
//             inTime: moment(item.inTime).format("hh:mm A") || "",
//             outTime: item.outTime ? moment(item.outTime).format("hh:mm A") : "",
//           }));
//           setRows(arr);
//           setIsLoading(false);

//           if (data.length > 0) {
//             const columns: GridColDef[] = [

//               {
//                 field: "serialNo",
//                 headerName: t("text.SrNo"),
//                 flex: .8,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 80,
//               },
//               {
//                 field: "m_memcd",
//                 headerName: t("text.MemberCode"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 140,
//               },
//               {
//                 field: "mname",
//                 headerName: t("text.MemberName"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 140,
//               },
//               {
//                 field: "mobileNo",
//                 headerName: t("text.mobileNo"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 120,
//               },
//               {
//                 field: "mem_type",
//                 headerName: t("text.MemberType"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 130,
//               },
//               {
//                 field: "vdate",
//                 headerName: t("text.VisitDate"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 100,
//               },
//               {
//                 field: "inTime",
//                 headerName: t("text.InTime"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 100,
//               },
//               {
//                 field: "outTime",
//                 headerName: t("text.OutTime"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 100,
//               },
//               {
//                 field: "spendtime",
//                 headerName: t("text.TimeSpend"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 130,
//               },
//               {
//                 field: "visit",
//                 headerName: t("text.Visit"),
//                 flex: 1,
//                 headerClassName: "MuiDataGrid-colCell",
//                 minWidth: 80,
//               },


//             ];
//             setColumns(columns as any);
//           }
//         });
//     } catch (error) {
//       console.error("Error fetching data:", error);

//     }
//   };



//   return (
//     <>
//       <div></div>
//       <Grid item lg={6} sm={6} xs={12} sx={{ marginTop: "3vh" }}>
//         <Card
//           style={{
//             width: "100%",
//             height: "50%",
//             backgroundColor: "#E9FDEE",
//             border: ".5px solid green ",
//           }}
//         >
//           <Paper
//             sx={{
//               width: "100%",
//               overflow: "hidden",
//               "& .MuiDataGrid-colCell": {
//                 backgroundColor: "#2B4593",
//                 color: "#fff",
//                 fontSize: 18,
//                 fontWeight: 800,
//               },
//             }}
//             style={{ padding: "10px" }}
//           >
//             <ConfirmDialog />
//             <Typography
//               gutterBottom
//               variant="h5"
//               component="div"
//               sx={{ padding: "20px" }}
//               align="left"
//             >
//               {t("text.VisitorInfo")}
//             </Typography>
//             <Divider />

//             <Box height={10} />


//             <ToastContainer />
//             <form onSubmit={formik.handleSubmit}>

//               <Grid item xs={12} container spacing={2}>
//                 <Grid item xs={12} sm={6} lg={6}  >
//                   <TextField
//                     label={t("text.VisitDate")}
//                     type="date"
//                     variant="outlined"
//                     fullWidth
//                     size="small"
//                     name="vdate"
//                     id="vdate"
//                     value={formik.values.vdate}
//                     placeholder={t("text.VisitDate")}
//                     onChange={formik.handleChange}
//                   />
//                 </Grid>


//                 <Grid item xs={12} sm={6} lg={6}  >
//                   <TextField
//                     label={t("text.MemberCode")}
//                     type="text"
//                     variant="outlined"
//                     fullWidth
//                     size="small"
//                     name="m_memcd"
//                     id="m_memcd"
//                     value={formik.values.m_memcd}
//                     placeholder={t("text.MemberCode")}
//                     onChange={formik.handleChange}
//                   />
//                   {/* <Autocomplete
//                     disablePortal
//                     id="combo-box-demo"
//                     options={memberCode}
//                     value={formik.values.m_memcd}
//                     fullWidth
//                     size="small"
//                     onChange={(event: any, newValue: any) => {
//                       formik.setFieldValue("m_memcd", newValue.value);
//                     }}
//                     renderInput={(params) => (
//                       <TextField
//                         {...params}
//                         label={t("text.MemberCode")}
//                         name="m_memcd"
//                         id="m_memcd"
//                         placeholder={t("text.MemberCode")}
//                       />
//                     )}
//                   /> */}

//                 </Grid>

               
//               {/* Department Filter */}
//               <Grid item xs={12} sm={6} md={4} lg={3}>
//                 <Autocomplete
//                   disablePortal
//                   id="department-autocomplete-dialog"
//                   options={Category_dept_Option}
//                   getOptionLabel={(option: any) => option?.label || ""}
//                   fullWidth
//                   size="small"
//                   onChange={(e: any, newValue: any) => {
//                     setDeptData(newValue ? newValue.value : "");
//                   }}
//                   renderInput={(params: any) => (
//                     <TextField {...params} label="Select Department" />
//                   )}
//                 />
//               </Grid>

//              {/* Program Filter */}
//               <Grid item xs={12} sm={6} md={4} lg={3}>
//                 <Autocomplete
//                   disablePortal
//                   id="program-autocomplete-dialog"
//                   options={Option}
//                   getOptionLabel={(option: any) => option?.label || ""}
//                   fullWidth
//                   size="small"
//                   onChange={(e: any, newValue: any) => {
//                     setProgData(newValue ? newValue.value : "");
//                   }}
//                   renderInput={(params: any) => (
//                     <TextField {...params} label="Select Program" />
//                   )}
//                 />
//               </Grid>






//                 <Grid xs={12} item>
//                   <div style={{ justifyContent: "space-between", flex: 2 }}>
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       style={{
//                         width: "30%",
//                         backgroundColor: "#059669",
//                         margin: "1%",
//                       }}
//                     >
//                       {t("text.show")}
//                     </Button>

//                     <Button
//                       type="reset"
//                       variant="contained"
//                       style={{
//                         width: "30%",
//                         backgroundColor: "#F43F5E",
//                         margin: "1%",
//                       }}
//                       onClick={() => formik.resetForm()}
//                     >
//                       {t("text.reset")}
//                     </Button>

//                     <Button
//                       type="reset"
//                       variant="contained"
//                       style={{
//                         width: "30%",
//                         backgroundColor: "#5682e8",
//                         margin: "1%",
//                       }}
//                       onClick={() => handlePrintClick()}
//                     >
//                       {t("text.Print")}
//                     </Button>
//                   </div>
//                 </Grid>
//               </Grid>
//             </form>


//             <Box>
//               <br></br>
//               <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
//                 <DataGrid
//                   rows={rows}
//                   columns={columns}
//                   autoHeight
//                   slots={{
//                     toolbar: GridToolbar,
//                   }}
//                   rowSpacingType="border"
//                   pagination={true}
//                   pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
//                     value: size,
//                     label: `${size}`,
//                   }))}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: 5 } },
//                   }}
//                   slotProps={{
//                     toolbar: {
//                       showQuickFilter: true,
//                     },
//                   }}
//                 />
//               </div>
//             </Box>
//             {/* )} */}
//           </Paper>
//         </Card>
//       </Grid>
//       {/* <ToastApp /> */}
//     </>
//   );
// }
